module.exports = __webpack_public_path__ + "static/media/winner.f12b3b6d.svg";